import { render } from "./order_details.vue?vue&type=template&id=44de444f"
import script from "./order_details.vue?vue&type=script&lang=js"
export * from "./order_details.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__